var map = {
	"./de/title-icon.png": "3vfL",
	"./en/title-icon.png": "2ERv",
	"./es/title-icon.png": "rGja",
	"./fr/title-icon.png": "MniD",
	"./ja/title-icon.png": "jBkS",
	"./ko/title-icon.png": "QkWH",
	"./pt/title-icon.png": "VhFw",
	"./ru/title-icon.png": "KPSR",
	"./tc/title-icon.png": "lv7H",
	"./th/title-icon.png": "/EFK"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "mJEl";